import { useCallback } from 'react';
import CoinStack from '@/assets/icons/CoinStack.svg';
import { Checkbox } from '@/components/Checkbox';
import { DiscountCardDisclosure } from '@/components/DiscountCardDisclosure';
import { TextField } from '@/components/TextField';
import { useCheckout } from '@/contexts/checkoutContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import { useLoyaltyCard } from './useLoyaltyCard';

export const LoyaltyCard = () => {
  const { checkoutData } = useCheckout();
  const { addPaymentInfo } = useDataLayer();
  const {
    applyPoints,
    pointsBalance,
    balanceMessage,
    handleApply,
    handleInputChange,
    helpText,
    loyaltyCardNumber,
  } = useLoyaltyCard();

  const handleExpand = useCallback(() => {
    addPaymentInfo('Loyalty Card', checkoutData.items || []);
  }, [addPaymentInfo, checkoutData.items]);

  return (
    <DiscountCardDisclosure
      icon={<CoinStack />}
      label="Eason Loyalty Points"
      onExpand={handleExpand}
    >
      <TextField
        helpText={helpText?.loyaltyCard}
        inputMode="numeric"
        label="Loyalty card number"
        onChange={handleInputChange}
        pattern="^[\d\s]{19}$"
        type="tel"
        value={loyaltyCardNumber}
      />
      {balanceMessage ? (
        <>
          <p>{balanceMessage}</p>
          {pointsBalance > 0 && (
            <Checkbox
                helpText={helpText?.applyLoyaltyBalance}
                isOffset={true}
                isSelected={applyPoints}
                label="Apply points to this order"
                onChange={handleApply}
            />
          )}
        </>
      ) : null}
    </DiscountCardDisclosure>
  );
};
